export default function scrollTo() {
  const exclude = ['#subscribe'];

  /**
   * Do scroll
   */
  function doScroll($target, delay = 0) {
    if (!$target.length) {
      console.log('no target');
      return;
    }

    let scrollTop = $target.offset().top;

    if ($target.is('.wp-block-columns')) {
      scrollTop -= 40;
    }

    setTimeout(function () {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop,
        },
        1000
      );
    }, delay);
  }

  /**
   * Clicking on link
   */
  $('a[href^="#"]')
    .filter(function () {
      return !exclude.includes($(this).attr('href'));
    })
    .on('click', function (e) {
      if ($(this).attr('href') === '#' || $(this).hasClass('no-scroll')) {
        return true;
      }
      e.preventDefault();

      doScroll($($(this).attr('href')));
    });

  /**
   * Scroll to element on page load
   */
  if (window.location.hash) {
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1);
    doScroll($(window.location.hash), 500);
  }
}
